import React, { useState } from "react";
import { useHistory } from "react-router";
// import { useHistory } from "react-router";
import { toast } from "react-toastify";
import {
  ActionButtonForUser,
  PageInnerContainer,
  // UserFollowingDetails,
  UserInfoBox,
  UserProfileInfo,
  // UserProfileInfoInner,
} from "../../../GobalStyled";
import { activeDeactivePostProfile, userDelete, clearReport } from "../Auth/_redux/authCrud";
import DeleteBlock from "../Modals/DeleteBlock";
import ReportInfo from "./components/ReportInfo";

export default function ViewReport(props) {
  const [activeTab, setActiveTab] = useState("info");
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(props.location.state.data);
  // console.log(userData)
  const [openModal, setOpenModal] = useState(false);
  const [parameter, setParameter] = useState({});
  const [modalLoder, setModalLoder] = useState(false);

  const baseurl = "https://d17am3tdlggecz.cloudfront.net/";

  const history = useHistory();

  const deleteAction = async () => {
    setModalLoder(true);
    if (parameter.name === "Delete") {
      let res = await userDelete(parameter.id);
      if (res.status === 200) {
        setModalLoder(false);
        setOpenModal(false);
        setLoading(false);
        history.push(props?.location?.state?.path);
        setUserData([]);
        toast.info(res.message, { theme: "colored" });
      } else {
        setModalLoder(false);
        setOpenModal(false);
        toast.error(res.message, { theme: "colored" });
      }
    }
    if (parameter.name === "Activate" || parameter.name === "Deactivate") {
      let req = {
        profileId: parameter.id,
        profileStatus: parameter.status,
      };
      let res = await activeDeactivePostProfile(req);
      if (res.status === 200) {
        setModalLoder(false);
        setOpenModal(false);
        history.push(props?.location?.state?.path);
        // getDetails();
        toast.info(res.message, { theme: "colored" });
      } else {
        setModalLoder(false);
        setOpenModal(false);
        toast.error(res.message, { theme: "colored" });
      }
    }
    if (parameter.name === "Clear") {
      let req = {
        reportIds: userData?.reportData?.map(report => report._id),
        profileId: userData?._id,
      }
      // console.log(req)
      let res = await clearReport(req);
      if (res.status === 200) {
        setModalLoder(false);
        setOpenModal(false);
        toast.info(res.message, { theme: "colored" });
        history.push(props?.location?.state?.path);
        setUserData([]);
      } else {
        setModalLoder(false);
        setOpenModal(false);
        toast.error(res.message, { theme: "colored" });
      }
    }
  };

  // const ApproveReport = (id) => {
  //   if (status !== 3) {
  //     setOpenModal(true);
  //     let para = {
  //       name: "Approve",
  //       body: "this Report",
  //       id: id,
  //       status: false,
  //     };
  //     setParameter(para);
  //   }
  // };

  const activDeactivate = (type, id) => {
    if (type === "Deactivate") {
      setOpenModal(true);
      let para = {
        name: "Deactivate",
        body: "this Business profile",
        id: id,
        status: false,
      };
      setParameter(para);
    } else {
      setOpenModal(true);
      let para = {
        name: "Activate",
        body: "this Business profile",
        id: id,
        status: true,
      };
      setParameter(para);
    }
  };

  const DeleteReport = (id) => {
    setOpenModal(true);
    let para = {
      name: "Delete",
      body: "this Business Profile",
      id: id,
    };
    setParameter(para);
  };

  const clearReportAction = (id) => {
    setOpenModal(true);
    let para = {
      name: "Clear",
      body: "this Business Profile",
      id: id,
    };
    setParameter(para);
  };

  // const Action = async () => {
  //   setModalLoder(true);
  //   let req = {
  //     feed_id: parameter.id,
  //     status: parameter.status,
  //   };

  //   let res = await actionOnFeed(req);
  //   if (res.status === 200) {
  //     setModalLoder(false);
  //     setOpenModal(false);

  //     toast.success(res.message, { theme: "colored" });
  //   } else {
  //     setModalLoder(false);
  //     setOpenModal(false);
  //     toast.error(res.message, { theme: "colored" });
  //   }
  // };

  if (loading) {
    return (
      <div className="LoaderWrapper">
        <div className="BackgroundLoader" />
      </div>
    );
  }

  return (
    <>
      {openModal && (
        <DeleteBlock
          open={openModal}
          close={() => setOpenModal(false)}
          confirmSumbit={deleteAction}
          parameter={parameter}
          loading={modalLoder}
        />
      )}

      {userData !== "" ? (
        <PageInnerContainer>
          <UserInfoBox>
            {/* <div style={{ height: "max-content", display: 'grid', gridTemplateColumns: 'repeat(2,1fr)' }}> */}
            <UserProfileInfo>
              {/* {userData?.postProfile_picture !== "" ? (
                <img
                  src={baseurl + userData?.postProfile_picture[2]}
                  alt="Profile"
                />
              ) : userData?.gender === "male" ? (
                <img src="../media/svg/avatars/001-boy.svg" alt="Profile" />
              ) : (
                <img src="../media/svg/avatars/002-girl.svg" alt="Profile" />
              )} */}
              {/* <div></div> */}
              {userData?.postProfile_picture &&
                userData.postProfile_picture.length > 0 &&
                userData.postProfile_picture.find(
                  (img) =>
                    img.toLowerCase().endsWith(".jpg") ||
                    img.toLowerCase().endsWith(".jpeg") ||
                    img.toLowerCase().endsWith(".png")
                ) ? (
                <button onClick={() =>
                  history.push("/user-details", {
                    id: userData._id,
                    path: props?.location?.state?.path,
                  })
                }
                  style={{ padding: 0, border: "none", background: "none" }}>
                  <img
                    src={
                      baseurl +
                      userData.postProfile_picture.find(
                        (img) =>
                          img.toLowerCase().endsWith(".jpg") ||
                          img.toLowerCase().endsWith(".jpeg") ||
                          img.toLowerCase().endsWith(".png")
                      )
                    }
                    alt="Profile"
                  />
                </button>
              ) : userData?.gender === "male" ? (
                <button onClick={() =>
                  history.push("/user-details", {
                    id: userData._id,
                    path: props?.location?.state?.path,
                  })
                }
                  style={{ padding: 0, border: "none", background: "none" }}>
                  <img src="../media/svg/avatars/001-boy.svg" alt="Profile" />
                </button>
              ) : (
                <button onClick={() =>
                  history.push("/user-details", {
                    id: userData._id,
                    path: props?.location?.state?.path,
                  })
                }
                  style={{ padding: 0, border: "none", background: "none" }}>
                  <img src="../media/svg/avatars/002-girl.svg" alt="Profile" />
                </button>
              )}
              <div className="d-flex flex-column gap-2 align-items-center justify-content-center">
                <div>
                  <button onClick={() =>
                    history.push("/user-details", {
                      id: userData._id,
                      path: props?.location?.state?.path,
                    })
                  }
                    style={{ padding: 0, border: "none", background: "none" }}>
                    <h4>{userData?.first_name + " " + userData?.last_name}</h4>
                    <h5>@ {userData?.user_name}</h5>
                    <h6 style={{ wordBreak: "break-word" }}>{userData?.userDetails?.map((item) => item.email)}</h6>
                    {/* <h6 style={{ wordBreak: "break-word" }}
                    >fdgdfhfghgfhgfhffxgdfgfghfghgfhfghfghfhfhfghvbhggfhfhfhgfhjgfjjhgjjhhhhhhhhhh
                    hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhggggggggggg@gmail.com</h6> */}
                  </button></div>
                <div className="d-flex flex-column gap-6 align-items-center justify-content-center mt-8">
                  <p >{userData?.count}</p>
                  <p className="text-[#000] text-sm text-center">Number of Reports</p>
                </div>
              </div>
            </UserProfileInfo>
            <ActionButtonForUser>
              {/* {userData?.profile_status === true ? ( */}
              {userData?.deletedByAdmin === true ? (null) : (<span
                className="bg-warning"
                style={{ padding: "10px", borderRadius: "25px" }}
                onClick={() => activDeactivate("Deactivate", userData?._id)}
              >
                Deactivate Profile
              </span>)}

              {/* ) : (
                <span
                  className="bg-success"
                  style={{ padding: "10px", borderRadius: "25px" }}
                  onClick={() => activDeactivate("Activate", userData?._id)}
                >
                  Activate Profile
                </span>
              )} */}
              {userData?.deletedByAdmin === true ? (<span
                className="Delete"
              // onClick={() => DeleteReport(userData?._id)}
              >
                Deleted
              </span>) : (
                <span
                  className="Delete"
                  onClick={() => DeleteReport(userData?._id)}
                >
                  Delete Profile
                </span>
              )}
              <span
                className="clear bg-success text-white"
                style={{ padding: "10px", borderRadius: "25px" }}
                onClick={() => clearReportAction(userData?.reportData?._id)}
              >
                Clear
              </span>
            </ActionButtonForUser>
            {/* <UserFollowingDetails>

            </UserFollowingDetails> */}

            {/* </div> */}
          </UserInfoBox>

          <div
            style={{
              textAlign: "center",
              borderBottom: "2px solid red",
              fontSize: "2rem",
              fontWeight: "500",
              paddingTop: "2%",
            }}
          >
            <div>
              <span
                className={activeTab === "info" && "active"}
                onClick={() => setActiveTab("info")}
              >
                Report Info
              </span>
            </div>
            {/* <div>
              <span
                className={activeTab === "video" && "active"}
                onClick={() => setActiveTab("video")}
              >
                Reported By
              </span>
            </div> */}
          </div>

          {activeTab === "info" && (
            <ReportInfo
              data={userData?.reportedByUserData}
              reportData={userData?.reportData}
            />
          )}
          {/* {activeTab === "video" && <ReportedByInfo data={userData} />} */}
        </PageInnerContainer>
      ) : (
        <span className="ml-3 spinner spinner-white"></span>
      )}
    </>
  );
}
